export function setCookie(name, value, expires) {
    let cookiePath = process.env.REACT_APP_COOKIE_PATH || window.location.hostname;
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; domain=${cookiePath}`;
}

export function setCookieExpirationDate() {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7);
    return expirationDate;
}